// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h4cBNLjpyBIopy0dc08L{padding:16px 24px 24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `h4cBNLjpyBIopy0dc08L`
};
export default ___CSS_LOADER_EXPORT___;
